import { render, staticRenderFns } from "./CustomDatePicker.vue?vue&type=template&id=644988da"
import script from "./CustomDatePicker.vue?vue&type=script&lang=ts"
export * from "./CustomDatePicker.vue?vue&type=script&lang=ts"
import style0 from "./CustomDatePicker.vue?vue&type=style&index=0&id=644988da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports